import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import {TranslateService} from '@ngx-translate/core';
import {StorageItem} from "../../enums/storage-item";
import {LocalStorageService} from "angular-2-local-storage";

@Component({
  selector: 'app-email-confirmation',
  templateUrl: './email-confirmation.component.html',
  styleUrls: ['./email-confirmation.component.scss']
})
export class EmailConfirmationComponent implements OnInit {
  token: string = this.route.snapshot.paramMap.get('id');
  emailConfirmed;
  emailChange;
  loading = true;
  locale = this.route.snapshot.queryParamMap.get('locale');
  constructor(
    private authService: AuthenticationService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private localStorage: LocalStorageService
  ) {
    translate.addLangs(['es', 'en']);
    translate.setDefaultLang('es');
    if (this.locale === 'es' || this.locale === 'en'){
      translate.use(this.locale);
    }
  }
  ngOnInit() {
    this.loading = true;
    this.authService.emailConfirmation(this.token).subscribe(
      (response: any) => {
        switch (response.typeConfirmation) {
          case 'EMAIL_CONFIRMATION':
            this.emailChange = false;
            this.emailConfirmed = true;
            break;
          case 'CHANGE_EMAIL_CONFIRMATION':
            this.emailChange = true;
            this.emailConfirmed = true;
            break;
          default:
            break;
        }
        this.loading = false;
      },
      error => {
        this.loading = false;
      }
    );
  }

}
